<template>
	<div >
		<div class="app-container">
			<el-descriptions title="检查项目" :column="2" border>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
						被抽样单位名称
					</template>
					 {{spcjxx.cyJgmcBcydw}}
				</el-descriptions-item>				
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
						被抽样单位地址
					</template>
					 {{spcjxx.cyXxdzBcydw}}
				</el-descriptions-item> 
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
						生产许可证号
					</template>
					 {{spcjxx.cyXkzbhBcydw}}
				</el-descriptions-item> 
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
						样品名称
					</template>
					 {{spcjxx.cyYpmc}}
				</el-descriptions-item> 
				<el-descriptions-item labelStyle="width:120px" span="2">
					<template slot="label" >						 
						食品种类
					</template>
					 {{spcjxx.cySpdl}}-{{spcjxx.cySpyl}}-{{spcjxx.cySpcyl}}-{{spcjxx.cySpxl}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
						样品规格
					</template>
					 {{spcjxx.cyYpgg}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
						生产日期
					</template>
					 {{spcjxx.cyScrq}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
						保质期
					</template>
					 {{spcjxx.cyBzq}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
						抽样单位名称
					</template>
					 {{spcjxx.cyDwmc}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
						抽样时间
					</template>
					 {{spcjxx.cyCysj}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
						检验机构名称
					</template>
					 {{spcjxx.cyJyjgmc}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
						检验目的
					</template>
					 {{spcjxx.cyJymd}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
						报告书编号
					</template>
					 {{spcjxx.bgJybgbh}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
						报告书编号
					</template>
					 {{spcjxx.bgJybgbh}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
						收检日期
					</template>
					 {{spcjxx.cySjrq}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
						报告日期
					</template>
					 {{spcjxx.bgRqBg}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
						标识生产企业名称
					</template>
					 {{spcjxx.cyQyzwmc}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
						检验项目
					</template>
					 {{spcjxx.xmJyxmmc}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
					 检验结果
					</template>
					 {{spcjxx.xmJyxmjg}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px" span=2>
					<template slot="label" >						 
					 检验依据
					</template>
					 {{spcjxx.xmYyjj}}
				</el-descriptions-item>				 
				<el-descriptions-item labelStyle="width:120px" >
					<template slot="label" >						 
					 结果判定
					</template>
					 {{spcjxx.xmJyjgpd}}
				</el-descriptions-item>
			</el-descriptions>
			 
			 
		</div>
	</div>
</template>

<script> 
	export default {
		name: 'Spcjxx',
		props: {
			//食品抽检信息
			spcjxx: {
				type: Object,
				require: true
			}
		},
		watch: {
			spcjxx(newValue, oldValue) {
				//this.init();
			},
			immediate: true,
			deep: true,
		},
		data() {
			return {
				 
			}
		},
		created() {
			//this.init();
			 
		},
		methods: {
			 
		}
	}
</script>

<style scoped>
	/deep/ .el-descriptions__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0px;
	}

	.el-title {
		box-sizing: border-box;
		font-size: 16px;
		font-weight: 700;
		color: #303133;
		padding-top: 10px;
		text-align: left;
	}
</style>
